import type { IAddress, IPlace } from "@bbj-types/address";
import type { IContact } from "@bbj-types/contact";
import type { OfferKind } from "@root/utils/enums/offer";
import { basicAxiosInstance } from "../axios";

export interface IPostParseOfferBody {
  text: string;
  kind: OfferKind;
}

export interface IPostParseOfferResponse {
  offerTexts: string[];
}

export interface IPostExtractOfferBody {
  offerText: string;
  kind: OfferKind;
}

export type TLlmContractType = "cdi" | "cdd" | "interim" | "stage" | "alternance" | "freelance";

export type TLlmExtractOfferContact = Partial<Omit<IContact, "place">> & {
  name?: string;
  mail?: string;
  place?: string;
};

export interface ILlmExtractJobOfferEnterprise {
  _id?: string;
  name?: string;
  contacts?: string[];
}

export interface ILlmExtractJobOffer {
  name: string;
  description: string;
  contractType: TLlmContractType[];
  isPermanent: boolean;
  url?: string;
  contractDuration?: {
    unit: "day" | "week" | "month" | "year";
    duration: number;
  };
  workWeeklyDuration?: number;
  startDate?: string;
  endDate?: string;
  address?: Partial<IAddress>;
  enterprise?: ILlmExtractJobOfferEnterprise;
  contact?: TLlmExtractOfferContact;
}

export interface ILlmExtractSocialOfferProvider {
  _id?: string;
  name?: string;
}

export interface ILlmExtractSocialOffer {
  name: string;
  description: string;
  isRemote: boolean;
  tags: string[];
  beneficiaries?: string;
  registrationModalities?: string;
  url?: string;
  financingModes?: string[];
  serviceStartDate?: string;
  serviceEndDate?: string;
  address?: Partial<IAddress>;
  provider?: ILlmExtractSocialOfferProvider;
  contact?: TLlmExtractOfferContact;
  perimeter?: Pick<IPlace, "_id" | "placeLabel">[];
}

export const postParseOffer = (data: IPostParseOfferBody, signal: AbortSignal) =>
  basicAxiosInstance.post<IPostParseOfferResponse>("/v2/offers/generate/parse", data, { signal });

export const postExtractOffer = <TRaw>(data: IPostExtractOfferBody, signal: AbortSignal) =>
  basicAxiosInstance.post<TRaw>("/v2/offers/generate/extract", data, { signal });
